import { ProcessingStatus } from './processing-status';
export class ProcessingStatusModel {

  key: string;
  nameDictionaryKey: string;
  status: ProcessingStatus[] = [];

  constructor(model: ProcessingStatusModel) {
    this.key = model.key;
    this.nameDictionaryKey = model.nameDictionaryKey;
    for (const status of model.status) {
      this.status.push(new ProcessingStatus(status));
    }
  }
}
